import { AdminLogin } from "@/login";
import { useAdminContext } from "@/state/adminContext";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/admin/login")({
  component: RouteComponent,
});

function RouteComponent() {
  const { admin } = useAdminContext();
  const router = useRouter();

  useEffect(() => {
    if (admin.id) {
      router.navigate({ to: "/admin" });
    }
  }, [admin.id]);

  return <AdminLogin />;
}
